"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _IdentityProvider = _interopRequireDefault(require("./IdentityProvider"));

var _UserExemption = _interopRequireDefault(require("./UserExemption"));

var _constants = require("../constants");

var _SamlSettingsDefaults;

var SamlSettingsDefaults = (_SamlSettingsDefaults = {}, (0, _defineProperty2.default)(_SamlSettingsDefaults, _constants.CONFIRMED_SAML_IDP, new _IdentityProvider.default()), (0, _defineProperty2.default)(_SamlSettingsDefaults, _constants.PENDING_SAML_IDP, new _IdentityProvider.default()), (0, _defineProperty2.default)(_SamlSettingsDefaults, _constants.REQUIREMENT, _constants.NOT_REQUIRED), (0, _defineProperty2.default)(_SamlSettingsDefaults, _constants.USER_EXEMPTIONS, new _immutable.List()), _SamlSettingsDefaults);

var SamlSettings =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(SamlSettings, _Record);

  function SamlSettings(data) {
    (0, _classCallCheck2.default)(this, SamlSettings);

    if (data) {
      data[_constants.CONFIRMED_SAML_IDP] = new _IdentityProvider.default(data[_constants.CONFIRMED_SAML_IDP]);
      data[_constants.PENDING_SAML_IDP] = new _IdentityProvider.default(data[_constants.PENDING_SAML_IDP]);
      data[_constants.USER_EXEMPTIONS] = new _immutable.List(data[_constants.USER_EXEMPTIONS].map(function (userExemption) {
        return new _UserExemption.default(userExemption);
      }));
    }

    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SamlSettings).call(this, data));
  }

  return SamlSettings;
}((0, _immutable.Record)(SamlSettingsDefaults, _constants.SAML_SETTINGS));

exports.default = SamlSettings;
module.exports = exports.default;